export function formatViews(n: number): string {
  if (n >= 10000) {
    const w = n / 10000;
    return `${w.toFixed(w >= 100 ? 0 : 1)}万`;
  }
  return `${n}`;
}

export function getCategoryColor(slug: string): string {
  switch (slug) {
    case "exclusive":
      return "bg-primary-100 text-primary-700";
    case "stars":
      return "bg-accent-100 text-accent-800";
    case "drama":
      return "bg-secondary-100 text-secondary-800";
    case "music":
      return "bg-background-200 text-foreground-700";
    default:
      return "bg-background-200 text-foreground-700";
  }
}